import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useRef } from 'react';
import './Popup.css';

// Poup container to edit some content who can't be edited in the editor-windows
// Reason : to many informations for the user so we move the edit in another popup
function Popup({ Component, componentProps }) {

    const modal = useModal();
    const popupRef = useRef(null);

    const onClose = () => {
        if(popupRef.current == undefined) return;

        const background = popupRef.current.children[0];
        const content = popupRef.current.children[1];
        
        background.style.animation = "unset";
        content.style.animation = "unset";

        // Animation reverse can' be done on css so we need to use requestAnimationFrame with a timeout
        // Todo Refactoring with a useEffect
        window.requestAnimationFrame(() => {

            background.style.opacity = "0";
            background.style.pointerEvents = "none";
            content.style.transform = "scale3d(0.5, 0.5, 0.5)";
            content.style.opacity = "0";
            setTimeout(() => modal.remove(), 500)
        });

    }

    return (
        <div ref={popupRef} className='popup'>
            <div className="background" onClick={onClose}></div>
            <div className='content'>
                <Component onClose={onClose} {...componentProps}/>
            </div>
        </div>
    )
}

Popup.defaultProps = {
    Component : <></>,
    componentProps : {}
}

export default NiceModal.create(Popup);
